import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import List from './icon-list.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <List {...validProps} />;
}
SvgComponent.iconName = 'list';

/**
 * @deprecated This is a legacy icon
 */
export const ListIcon = svgIconWrapper(SvgComponent);
